module.exports = __webpack_public_path__ + "img/logo-mobile.158deb62.png";